import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function ResiliencePatterns() {
    return (
        <TopicLayout
            title="Timeouts, retries & circuit breakers"
            intro="Bound how long a caller waits on a dependency, retry failures safely, and stop calling a dependency that is already failing so it gets a chance to recover instead of being buried under retries."
            diagram={
                <Diagram viewBox="0 0 560 240">
                    <text x={280} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Circuit breaker state machine</text>
                    <Box x={40} y={30} width={120} height={48} label="Closed" sublabel="calls flow through"/>
                    <Box x={400} y={30} width={120} height={48} label="Open" sublabel="calls fail fast" accent/>
                    <Box x={220} y={170} width={120} height={48} label="Half-open" sublabel="one trial request"/>

                    <Arrow x1={160} y1={54} x2={400} y2={54} label="too many failures"/>
                    <Arrow x1={405} y1={78} x2={245} y2={170} label="cooldown"/>
                    <Arrow x1={240} y1={170} x2={130} y2={78} label="trial succeeds"/>
                    <Arrow x1={315} y1={170} x2={515} y2={78} label="trial fails" dashed muted/>
                </Diagram>
            }
            useWhen={[
                'Any call to a network dependency: it can hang, so give it a timeout; it can fail transiently, so retry with backoff and jitter; it can fail persistently, so a circuit breaker should stop hammering it.',
                'Multiple dependencies share a resource pool, such as threads or connections — isolate them (a bulkhead) so one slow dependency cannot starve calls to the others.'
            ]}
            tradeOff="Retries turn a transient blip into a fast recovery, but a retry storm from many callers can turn a struggling dependency into a dead one — always pair retries with backoff, jitter and a cap. A circuit breaker trades a few fast failures for protecting the dependency and the caller's own resources, at the cost of extra state and tuning (failure threshold, cooldown, trial volume) that is easy to get wrong."
            ruleOfThumb="Give every outbound call a timeout, retry only idempotent operations with exponential backoff and jitter, and wrap dependencies prone to cascading failure in a circuit breaker with bulkheaded resource pools."
        />
    )
}
